import { formatDate } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';
import { useSelectedAppLanguage } from '@/hooks/company/useSelectedAppLanguage';

export interface EvaluationPeriodBounds {
    start?: string;
    end?: string;
}

export const useEvaluationPeriodLabel = () => {
    const { t } = useAmelioTranslations();
    const language = useSelectedAppLanguage();

    return ({ start, end }: EvaluationPeriodBounds): string => {
        const startLabel = start
            ? formatDate({ date: start, language, timezone: 'UTC' })
            : undefined;
        const endLabel = end ? formatDate({ date: end, language, timezone: 'UTC' }) : undefined;

        if (startLabel && endLabel) {
            return t('cycleEvaluationDashboard.evaluationPeriod.range', {
                start: startLabel,
                end: endLabel,
            });
        }

        return startLabel ?? endLabel ?? t('cycleEvaluationDashboard.evaluationPeriod.notSet');
    };
};
